import React from 'react';
import './Footer.css';


const footer = props => (

    <footer className="footer">
        All rights reserved
    </footer>

)

export default footer;